export const ENABLE_INTERRAIL = true;